import { Button } from "@/common/components/button";
import { ILargeCardProps, LargeCard } from "../../stats/subs/LargeCard";
import {
  getSalesTableData,
  newFundRequestForm,
  salesStatisticCards,
  salesTableHeaders,
  salesTableKeys,
} from "../data";
import { FinancialWrapper } from "../style";
import Table from "@/common/components/Table";
import { Pagination } from "@/common/components/pagination";
import useQuery from "@/hooks/useQuery";
import { FINANCIAL_REPORT_URL } from "@/common/constants";
import { useState } from "react";
import { Modal } from "@/common/components/modal";
import Form from "@/common/components/form/Form";
import { KeyValueObj } from "@/common/types";
import useAuth from "@/hooks/useContexts";
import { useApiCallHandling } from "@/hooks/useApiCallHandling";
import { IFundRequestForm } from "@/common/types/others";

const PharmacyHeadFinancialManagement = () => {
  const [salesPerpage, setSalesPerpage] = useState(10);
  const [newRequestModal, setNewRequestModal] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const makeRequest = useApiCallHandling();
  const { auth } = useAuth();
  const user = auth?.user;
  const {
    data: { data },
    meta: salesMeta,
    loading: salesLoading,
  } = useQuery(
    FINANCIAL_REPORT_URL +
      `/sales-performance?per_page=${salesPerpage}&page=${salesPerpage}`
  );

  const { data: drfStats } = useQuery(FINANCIAL_REPORT_URL + `/stats`);

  const handleNewFundSubmit = (data: IFundRequestForm) => {
    setLoading(true);
    const payload = { ...data, request_type: "pharmacy_head_request" };
    makeRequest(
      FINANCIAL_REPORT_URL + "/fund-allocation-request",
      "POST",
      payload,
      () => {
        setNewRequestModal(false);
      },
      () => {},
      () => {
        setLoading(false);
      }
    );
  };

  return (
    <FinancialWrapper>
      <div className="card-wrapper">
        {salesStatisticCards(drfStats)?.map((card: ILargeCardProps) => (
          <LargeCard
            color={card?.color}
            icon={card?.icon}
            value={card?.value}
            title={card?.title}
          />
        ))}
      </div>
      <div className="cta-stock">
        <Button onClick={() => setNewRequestModal(true)}>Request Fund</Button>
        <Button secondary>Export</Button>
      </div>
      <div className="table-wrapper">
        <Table
          tableHeaders={salesTableHeaders}
          tableKeys={salesTableKeys}
          tableData={getSalesTableData(data)}
          tableTitle="Fund Allocation Request"
          tableSubtitle={(salesMeta?.total_count ?? "0") + " Requests"}
          loading={salesLoading}
          spaced
          rowLineColor="light"
        />
        <Pagination
          pageCount={salesMeta?.total_pages}
          onNextPage={(event: KeyValueObj) => setSalesPerpage(event.selected)}
          onPerPageChange={(event: KeyValueObj) =>
            setSalesPerpage(event?.target?.value)
          }
        />
      </div>
      <Modal
        title="New Fund Request"
        isOpen={newRequestModal}
        close={() => setNewRequestModal(false)}
      >
        <div className="modal">
          <Form
            formInputs={newFundRequestForm(user)}
            processInputs={handleNewFundSubmit}
            loadingState={loading}
          />
        </div>
      </Modal>
    </FinancialWrapper>
  );
};

export default PharmacyHeadFinancialManagement;
